
export const InfoUserURL = "/api/v1/info_user"
export const ListUserURL = "/api/v1/list_user"
export const CreateUserURL = "/api/v1/add_user"
export const DeleteUserURL = "/api/v1/delete_user"
export const EditUserURL = "/api/v1/update_user"
export const ValidateUserURL = "/api/v1/validate_user"
export const LogoutUserURL = "/api/v1/logout_user"
export const GetLoginPublicKeyURL = "/api/v1/get_login_public_key"
export const ChangePasswordURL = "/api/v1/change_password"
export const BatchResetUserPasswordURL = "/api/v1/batch_reset_user_password"

export const ListRoleURL = "/api/v1/list_role"
export const CreateRoleURL = "/api/v1/create_role"
export const UpdateRoleURL = "/api/v1/update_role"

export const ListLivingURL = "/api/v1/list_living"
export const CreateLivingURL = "/api/v1/add_living"
export const DeleteLivingURL = "/api/v1/delete_living"
export const EditLivingURL = "/api/v1/update_living"
// picture
export const LIST_PICTURE = "/api/v1/list_picture"
export const ADD_PICTURE = "/api/v1/add_picture"
export const UPDATE_PICTURE = "/api/v1/update_picture"
export const DELETE_PICTURE = "/api/v1/delete_picture"
// video
export const LIST_VIDEO = "/api/v1/list_video"
export const ADD_VIDEO = "/api/v1/add_video"
export const UPDATE_VIDEO = "/api/v1/update_video"
export const DELETE_VIDEO = "/api/v1/delete_video"
// audio
export const LIST_AUDIO = "/api/v1/list_audio"
export const ADD_AUDIO = "/api/v1/add_audio"
export const UPDATE_AUDIO = "/api/v1/update_audio"
export const DELETE_AUDIO = "/api/v1/delete_audio"
// text
export const LIST_TEXT = "/api/v1/list_text"
export const ADD_TEXT = "/api/v1/add_text"
export const UPDATE_TEXT = "/api/v1/update_text"
export const DELETE_TEXT = "/api/v1/delete_text"

export const ListDepartmentURL = "/api/v1/list_department"
export const CreateDepartmentURL = "/api/v1/create_department"
export const DeleteDepartmentURL = "/api/v1/delete_department"
export const UpdateDepartmentURL = "/api/v1/update_department"

export const ListMenuURL = "/api/v1/list_menu"
export const MineMenuURL = "/api/v1/list_menu/mine"
export const CreateMenuURL = "/api/v1/create_menu"
export const DeleteMenuURL = "/api/v1/delete_menu"
export const UpdateMenuURL = "/api/v1/update_menu"

export const ListDictionaryURL = "/api/v1/list_dictionary"
export const CreateDictionaryURL = "/api/v1/create_dictionary"
export const UpdateDictionaryURL = "/api/v1/update_dictionary"
export const DeleteDictionaryURL = "/api/v1/delete_dictionary"
export const ListDictionaryValueURL = "/api/v1/list_dictionary_value"
export const CreateDictionaryValueURL = "/api/v1/create_dictionary_value"
export const UpdateDictionaryValueURL = "/api/v1/update_dictionary_value"
export const DeleteDictionaryValueURL = "/api/v1/delete_dictionary_value"

export const UPLOAD_FILE = "/api/v1/upload_file" //文件上传
export const GET_FILE_URL = "/api/v1/get_file"
export const INFO_FILE_URL = "/api/v1/info_file"
export const LIST_FILE_URL = "/api/v1/list_file"

export const ListZoneURL = '/api/v1/list_zone'
export const CreateZoneURL = '/api/v1/create_zone'
export const UpdateZoneURL = '/api/v1/update_zone'
export const DeleteZoneURL = '/api/v1/delete_zone'
